<template>
  <section id="country-tab-faqs" class="wrapper-tab-faqs">
    <h2 class="subtitle-content">{{
      $t(`${base}.title`, { name: country.name })
    }}</h2>

    <el-collapse v-model="current" accordion>
      <el-collapse-item
        v-for="(faq, index) in faqs"
        :key="index"
        :title="faq.title"
        :name="`faq-${index}`"
      >
        <p>{{ faq.description }}</p>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchTabFaqs',
  data() {
    return {
      base: 'search.country.faqs',
      current: 'faq-0',
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({ name: state.header.name }),
      faqs: 'faqs',
    }),
  },
}
</script>

<style lang="scss">
section.wrapper-tab-faqs {
  .el-collapse {
    padding: 20px;
    background-color: white;
    border-color: transparent;

    .el-collapse-item__header {
      font-size: 18px;
      font-weight: 700;
      height: 75px;

      &:not(.is-active) {
        border-color: #9f9f9f;
      }
    }

    &-item {
      &.is-active {
        .el-collapse-item__wrap {
          border-bottom-color: transparent;
        }
      }

      &:last-child {
        .el-collapse-item__header,
        .el-collapse-item__wrap {
          border-bottom-color: transparent;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .el-collapse {
      .el-collapse-item__header {
        font-size: 14px;
        height: 75px;
        line-height: 1.8;
      }
    }
  }
}
</style>
